import { getGPPData } from './api.js';
const getConsentState = async () => {
    let doNotSell = false;
    const gppData = await getGPPData();
    const applicableSection = gppData.applicableSections[0];
    const supportedAPI = gppData.supportedAPIs.find((api) => api.startsWith(`${String(applicableSection)}:`));
    const parsedSectionKey = supportedAPI ? supportedAPI.split(":")[1] : void 0;
    const parsedSection = parsedSectionKey ? gppData.parsedSections[parsedSectionKey] : void 0;
    if (parsedSection) {
        doNotSell = parsedSection.SaleOptOut !== 2 || parsedSection.Gpc;
    }
    return {
        doNotSell,
        signalStatus: gppData.signalStatus
    };
};
export { getConsentState };
